import SourceIcon from "@mui/icons-material/Source";
import { useTheme } from "@mui/material";
import classNames from "classnames";

import { useEphemeralWorkspaceState } from "../../WorkspaceCtx/hooks";

import { DatasetInfo } from "./DatasetInfo";
import styles from "./DatasourceInfo.module.css";
import { FileInfo } from "./FileInfo";

interface DatasourceInfoProps {
  className?: classNames.Argument;
}

export function DatasourceInfo(props: DatasourceInfoProps) {
  const { isDataLoading, files } = useEphemeralWorkspaceState();
  const theme = useTheme();

  const datasetIds = [
    ...new Set<string>(
      files.map((f) => f.association_id).filter((id) => id !== undefined),
    ),
  ];

  return (
    <div className={classNames(props.className, styles.threePanelGrid)}>
      <div className={styles.iconInfo}>
        <div
          className={styles.iconContainer}
          style={{
            backgroundColor: theme.palette.action.hover,
          }}
        >
          <SourceIcon
            fontSize="small"
            sx={{
              color: theme.palette.text.secondary,
            }}
          />
        </div>
      </div>
      <div className={styles.datasetInfo}>
        <DatasetInfo
          isDatasetsLoading={isDataLoading}
          datasetIds={datasetIds}
        />
      </div>
      <div className={styles.fileInfo}>
        <FileInfo isFilesLoading={isDataLoading} files={files} />
      </div>
    </div>
  );
}
